let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3wY4G")).then(() => parcelRequire('7EiCp'));